(function() {
    'use strict';

    angular
        .module('bluebookApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('rcopia-instruction', {
            parent: 'entity',
            url: '/rcopia-instruction',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'RcopiaInstructions'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/rcopia-instruction/rcopia-instructions.html',
                    controller: 'RcopiaInstructionController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
            }
        })
        .state('rcopia-instruction-detail', {
            parent: 'entity',
            url: '/rcopia-instruction/{id}',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'RcopiaInstruction'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/rcopia-instruction/rcopia-instruction-detail.html',
                    controller: 'RcopiaInstructionDetailController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                entity: ['$stateParams', 'RcopiaInstruction', function($stateParams, RcopiaInstruction) {
                    return RcopiaInstruction.get({id : $stateParams.id}).$promise;
                }],
                previousState: ["$state", function ($state) {
                    var currentStateData = {
                        name: $state.current.name || 'rcopia-instruction',
                        params: $state.params,
                        url: $state.href($state.current.name, $state.params)
                    };
                    return currentStateData;
                }]
            }
        })
        .state('rcopia-instruction-detail.edit', {
            parent: 'rcopia-instruction-detail',
            url: '/detail/edit',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/rcopia-instruction/rcopia-instruction-dialog.html',
                    controller: 'RcopiaInstructionDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['RcopiaInstruction', function(RcopiaInstruction) {
                            return RcopiaInstruction.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('^', {}, { reload: false });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('rcopia-instruction.new', {
            parent: 'rcopia-instruction',
            url: '/new',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/rcopia-instruction/rcopia-instruction-dialog.html',
                    controller: 'RcopiaInstructionDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: function () {
                            return {
                                clinicalInstruction: null,
                                sequence: null,
                                action: null,
                                dose: null,
                                doseUnit: null,
                                route: null,
                                doseTiming: null,
                                asNeeded: null,
                                y: null,
                                doseOther: null,
                                doseDuration: null,
                                doseDurationUnit: null,
                                conjunction: null,
                                id: null
                            };
                        }
                    }
                }).result.then(function() {
                    $state.go('rcopia-instruction', null, { reload: 'rcopia-instruction' });
                }, function() {
                    $state.go('rcopia-instruction');
                });
            }]
        })
        .state('rcopia-instruction.edit', {
            parent: 'rcopia-instruction',
            url: '/{id}/edit',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/rcopia-instruction/rcopia-instruction-dialog.html',
                    controller: 'RcopiaInstructionDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['RcopiaInstruction', function(RcopiaInstruction) {
                            return RcopiaInstruction.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('rcopia-instruction', null, { reload: 'rcopia-instruction' });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('rcopia-instruction.delete', {
            parent: 'rcopia-instruction',
            url: '/{id}/delete',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/rcopia-instruction/rcopia-instruction-delete-dialog.html',
                    controller: 'RcopiaInstructionDeleteController',
                    controllerAs: 'vm',
                    size: 'md',
                    resolve: {
                        entity: ['RcopiaInstruction', function(RcopiaInstruction) {
                            return RcopiaInstruction.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('rcopia-instruction', null, { reload: 'rcopia-instruction' });
                }, function() {
                    $state.go('^');
                });
            }]
        });
    }

})();
